// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormGroup, FormControl, Button } from 'react-bootstrap';
import { flowRight as compose } from 'lodash';
import { gql } from '@apollo/client';
// Internal Components
import Loader from '../../Loader';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import messages from '../../../locale/jsonMessages';
// Redux Action
import { openSmsVerificationModal, closeSmsVerificationModal } from '../../../actions/SmsVerification/modalActions';
import { withMutation } from '../../../hoc/withGraphql';
import getPhoneDataQuery from '../getUserData.graphql';

import cs from '../../../components/commonStyle.css';
import s from './VerifyPhoneNumberForm.css';

class VerifyPhoneNumberForm extends Component {

  static propTypes = {
    fieldType: PropTypes.string,
    formatMessage: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      verificationCode: '',
      submitting: false,
      error: null
    }
    this.submitForm = this.submitForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { formatMessage } = this.props.intl;
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }



  async submitForm() {
    const { mutate } = this.props;
    const { formatMessage } = this.props.intl;
    const { verificationCode } = this.state;
    let error = null, submitting = false;
    if (!verificationCode) {
      error = {
        verificationCode: formatMessage(messages.verificationCodeRequired)
      };
    } else if (isNaN(verificationCode)) {
      error = {
        verificationCode: formatMessage(messages.verificationCodeRequired)
      };
    }

    submitting = (error === null) ? true : false;

    this.setState({
      submitting,
      error
    });

    if (error === null && submitting) {
      const { data } = await mutate({
        variables: {
          verificationCode: Number(verificationCode)
        },
        refetchQueries: [{
          query: getPhoneDataQuery
        }]
      });

      if (data?.VerifyPhoneNumber) {
        if (data?.VerifyPhoneNumber?.status === '200') {
          showToaster({ messageId: 'phoneNumberVerify', toasterType: 'success' })
        } else {
          error = {
            verificationCode: 'We were unable to validate your phone number. Please try again.'
          };
        }
      }
    }

    if (this.refs.verifyPhoneNumberForm) {
      this.setState({ submitting: false, error });
    }

  }

  render() {
    const { countryCode, phoneNumber, closeSmsVerificationModal } = this.props;
    const { formatMessage } = this.props.intl;
    const { verificationCode, submitting, error } = this.state;

    return (
      <div ref="verifyPhoneNumberForm" className={cx(cs.commonBorderSection, cs.spaceBottom2, 'whiteBgColor')}>
        <FormGroup className={s.spaceBottom3}>
          <label className={cx(cs.commonMediumText, cs.fontWeightNormal)}>
            <span className={cs.greyText}><FormattedMessage {...messages.weHaveSentVerificationCode} />{' '}</span>
            <span>{countryCode}<span>{' '}</span>{phoneNumber}.</span>
          </label>
        </FormGroup>
        <FormGroup className={cs.noMarginBottom}>
          <label className='commonLabelText'><FormattedMessage {...messages.verificationCodeLabel} />:</label>
          <div className={cx(cs.dFlexContainer, s.flexWrap)}>
            <div>
              <FormControl
                name={'verificationCode'}
                value={verificationCode}
                placeholder={formatMessage(messages.enterOtpDigit)}
                type={'text'}
                maxLength={4}
                className={cx('commonInputField', s.otpField)}
                onChange={this.handleChange} />
              {error && error.verificationCode && <span className={cs.errorMessage}>{error.verificationCode}</span>}
            </div>
            <div className={cx('doubleBtnDFlexStart', cs.spaceBottom2)}>
              <Button className={cx(cs.btnPrimaryBorder, cs.btnMedium, s.cancelBtn)} onClick={closeSmsVerificationModal}>
                <FormattedMessage {...messages.cancel} />
              </Button>
              <Loader
                containerClass={s.btnContainer}
                type={"button"}
                buttonType={"button"}
                className={cx(cs.btnPrimary, cs.btnMedium, 'loaderButtonFlex')}
                disabled={submitting}
                show={submitting}
                label={formatMessage(messages.verify)}
                handleClick={this.submitForm}
              />
            </div>
          </div>
        </FormGroup>
        <p className={cx(cs.fontWeightNormal, cs.greyText, cs.commonMediumText)}><FormattedMessage {...messages.tryAgain} /></p>
      </div>
    )
  }

}

const mapState = (state) => ({
  profileId: state.account.data.profileId
});

const mapDispatch = {
  openSmsVerificationModal,
  closeSmsVerificationModal
};

export default compose(
  injectIntl,
  withStyles(cs, s),
  connect(mapState, mapDispatch),
  withMutation(gql`
    mutation VerifyPhoneNumber($verificationCode: Int!) {
      VerifyPhoneNumber(verificationCode: $verificationCode) {
          status
      }
    }
  `)
)(VerifyPhoneNumberForm);